module.exports = __webpack_public_path__ + "static/kelsey-logo-beta-web-4e30f6285d25ba276ed8169d8fb4f7ea.svg";